import React from "react";
import "./Sspartone.css";
import partImg from "../../../Gallery/ServicesImages/material/img1.jpg"; // keep your image path same

function Sspartone() {
  return (
    <div className="sspart_wrapper">

      {/* HERO SECTION */}
      <section className="sspart_hero">
        <div className="sspart_container">

          <div className="sspart_image">
            <img src={partImg} alt="SS316L Parts" />
          </div>

          <div className="sspart_content">
            <h1>SS316L Precision Components</h1>
            <div className="sspart_line"></div>

            <p>
              SS316L components are manufactured using advanced additive 
              manufacturing followed by precision post-processing to achieve 
              exceptional dimensional accuracy and surface quality.
            </p>

            <p>
              These parts are optimized for corrosion resistance, structural 
              integrity, and high mechanical performance. Post-machining 
              operations ensure micron-level tolerances across multiple 
              critical surfaces.
            </p>
          </div>

        </div>
      </section>

    

    </div>
  );
}

export default Sspartone;
